import React from 'react'
import { Link } from 'react-router-dom'
const Footer = () => {
  return (
    <div className='footer'>
        <p className='text-center'>
        All right reserved &copy; 2025.
        </p>
    </div>
  )
}

export default Footer
